export default "__VITE_ASSET__DfyTn1xX__"